<template>
    <modal :show="pdata" v-if="pdata" @close="closeModal" :closeOnbackdrop="false" id="promoteModal">
        <template slot="header">
            <input type="hidden" v-model="reseter.counter">
            <h3>PROMOTE TO {{ pdata.details.type == 'final' ? 'FINAL' : 'INITIAL' }} - Step {{ step }}/2</h3>
        </template>
        <template>
            <div class="modal-step" v-show="step == 1">
                <div class="row pdf-row" v-if="pdata.id == 'new'">
                    <div class="col-md-4">
                        <input type="text" v-model="pdata.project.project_name" required ref="project_name" placeholder="Project Name" class="form-control" maxlength="100">
                    </div>
                    <div class="col-md-4">
                        <select ref="customer_id" v-model="pdata.project.customer_id" required class="form-control" @change="getRelatedData">
                            <option value="">Select Customer</option>
                            <option v-for="(cust, cid) in pdata.customers" :key="cid" :value="cust.id">{{ cust.name }}</option>
                        </select>
                    </div>
                    <div class="col-md-4">
                        <select v-model="pdata.project.phase" required ref="phase" class="form-control">
                            <option value="">Select Project Type</option>
                            <option value="modernization">Modernization</option>
                            <option value="construction">Construction</option>
                        </select>
                    </div>
                    <div class="col-md-4">
                        <input type="text" v-model="pdata.project.customer_name" required ref="customer_name" placeholder="Contact Name" class="form-control" maxlength="100">
                    </div>
                    <div class="col-md-4">
                        <input type="text" v-model="pdata.project.customer_email" required ref="customer_email" placeholder="Contact Email" class="form-control" maxlength="100">
                    </div>
                    <div class="col-md-4">
                        <masked-input mask="\+11 (111) 111-1111" v-model="pdata.project.customer_phone" class="form-control" placeholder="Contact Phone" ref="customer_phone" autocomplete="disabled"/>
                    </div>
                </div>
                <div class="row pdf-row">
                    <div class="col-md-4">
                        <select ref="phase" v-model="pdata.project.type" required class="form-control" @change="getRelatedData">
                            <option value="">Select Price Type</option>
                            <option value="regular">Standard</option>
                            <option value="stock">Stock</option>
                        </select>
                    </div>
                    <div class="col-md-4">
                        <input ref="priceLevel" v-model="pdata.details.level_desc" type="text" placeholder="Price Level" disabled class="form-control">
                    </div>
                    <div v-if="pdata.id == 'new'" class="col-md-4">
                        <input ref="contract_number" v-model="pdata.project.contract_number" type="text" placeholder="Contract Number" class="form-control" maxlength="128">
                    </div>
                </div>
                <div class="row pdf-row">
                    <div class="col-md-4">
                        <div class="pdf-group">
                            <label>Machine Data Sheet (Portrait)</label>
                            <input type="file" ref="pdf_datasheet" accept="application/pdf" multiple="" @change="storeFile('pdf_datasheet')">
                        </div>
                    </div>
                    <template v-if="pdata.details.type == 'final'">
                        <div class="col-md-4 for-promote-final" style="display: block;">
                            <div class="pdf-group">
                                <label>Drawings (Landscape)</label>
                                <input type="file" ref="pdf_drawing" accept="application/pdf" multiple="" @change="storeFile('pdf_drawing')">
                            </div>
                        </div>
                        <div class="col-md-4 for-promote-final" style="display: block;">
                            <div class="pdf-group">
                                <label>Traction (Portrait)</label>
                                <input type="file" ref="pdf_traction" accept="application/pdf" multiple="" @change="storeFile('pdf_traction')">
                            </div>
                        </div>
                        <div class="col-md-4 for-promote-final" style="display: block;">
                            <div class="pdf-group">
                                <label>Reaction Forces (Portrait) <small>(Optional)</small></label>
                                <input type="file" ref="pdf_reaction" accept="application/pdf" multiple="" @change="storeFile('pdf_reaction')">
                            </div>
                        </div>
                        <div class="col-md-4 for-promote-final" style="display: block;">
                            <div class="pdf-group">
                                <label>Drill Template (Landscape) <small>(Optional)</small></label>
                                <input type="file" ref="pdf_drill" accept="application/pdf" multiple="" @change="storeFile('pdf_drill')">
                            </div>
                        </div>
                        <div class="col-md-4 for-promote-final" style="display: block;">
                            <div class="pdf-group">
                                <label>Datatag (Landscape) <small>(Optional)</small></label>
                                <input type="file" ref="pdf_datatag" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" multiple="" @change="storeFile('pdf_datatag')">
                            </div>
                        </div>
                        <div class="col-md-4 for-promote-final" style="display: block;">
                            <div class="pdf-group">
                                <label>Crate Label (Landscape) <small>(Optional)</small></label>
                                <input type="file" ref="pdf_crate" accept="application/pdf" multiple="" @change="storeFile('pdf_crate')">
                            </div>
                        </div>
                        <div class="col-md-4 for-promote-final" style="display: block;">
                            <div class="pdf-group">
                                <label>CAD <small>(Optional)</small></label>
                                <input type="file" ref="pdf_cad" accept=".dwg" multiple="" @change="storeFile('pdf_cad')">
                            </div>
                        </div>
                    </template>
                </div>
            </div>

            <div class="modal-step" v-show="step == 2">
                <div>
                    <div>
                        <button
                            class="btn pt-2 pb-2"
                            @click="manageWarnings">
                            <span class="fas fa-gear">&nbsp;</span> Warning Notes
                        </button>
                    </div>
                    <transition name="fade">
                        <div v-if="showManageWarningNotes" class="warning-table-container">
                            <table v-for="(warningNote, wnCn) in warningNotes" :key="`wncn-${wnCn}`" class="warning-table">
                                <tbody>
                                    <tr>
                                        <th colspan="2" class="wcar-header">Car {{ warningNote.car_id_number }}</th>
                                        <th class="warning-code-header">Warning Number</th>
                                        <th class="warning-header">Warning Message</th>
                                    </tr>
                                    <tr v-for="(wnDetail, wnDIndex) in warningNote.rows" :key="wnDetail.id">
                                        <td class="rm-warning"><a class="js-item-remove" @click="removeWarningNote(wnCn, wnDIndex, wnDetail.id)">×</a></td>
                                        <td class="warning-category">
                                            <template v-if="wnDetail.action !== 'add'">
                                                <span>{{ groups[`${wnDetail.group_type}`] }}</span>
                                            </template>
                                            <template v-else>
                                                <select :ref="`group_type_${wnDIndex}_${wnCn}_${wnDetail.id}`" v-model="wnDetail.group_type" required class="wn-category">
                                                    <option value="">Select Category</option>
                                                    <option v-for="(wnLabel, wnGroup) in groups" :value="wnGroup" :key="wnGroup">{{ wnLabel }}</option>
                                                </select>
                                            </template>
                                        </td>
                                        <td class="warning-code-td">
                                            <select :ref="`warning_code_${wnDIndex}_${wnCn}_${wnDetail.id}`" v-model="wnDetail.warning_code" class="wn-warning-code" @change="handleWarningCodeChange($event, wnCn, wnDIndex)">
                                                <option value="">Select Warning Number</option>
                                                <option v-for="wnCode in warningMessages" :value="wnCode.warning_number" :key="wnCode.warning_number">{{ wnCode.warning_number }}</option>
                                            </select>
                                        </td>
                                        <td class="warning-note-td">
                                            <input v-model="wnDetail.warning_msg" :ref="`warn_msg_${cn}_${wnIndex}_${wnDetail.id}`" required type="text" class="warning-note">
                                        </td>
                                    </tr>
                                    <tr v-if="warningNote.rows.length < 1">
                                      <td class="rm-warning rm-warning-none">&nbsp;</td>
                                      <td class="warning-category warning-category-none">&nbsp;</td>
                                      <td class="warning-code-td warning-code-td-none">&nbsp;</td>
                                      <td class="warning-note-td warning-note-td-none">&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td class="wn-remove">&nbsp;</td>
                                        <td class="add-wnbutton" colspan="3">
                                            <a class="btn car-btn" @click="addWarning(wnCn)">Add Warning</a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </transition>
                </div>
                <table class="tdm_table">
                    <tbody class="tdm_content" v-for="(car, cn) in pdata.cars" :key="cn">
                        <tr class="tdm_heading">
                            <th colspan="2">
                                Car 
                                <template v-if="pdata.id == 'new'">
                                    <input type="text" v-model="pdata.carids[cn]" :ref="`car_id_${cn}`" required :disabled="step != 2" @blur="handleNewCarName($event, cn)">
                                    <a @click="removeCar(cn)" v-if="cn != 1" class="rmv-car">Remove Car</a>
                                </template>
                                <template v-else>
                                    <span class="tdm_carname">{{ car.details.car_id_number }}</span>
                                </template>
                            </th>
                            <th class="tdm_label">Label</th>
                            <th class="tdm_qty">Qty</th>
                            <th>Item</th>
                            <th>Detail</th>
                            <th class="tdm_uprice">Unit Price</th>
                            <th class="tdm_price">Price</th>
                        </tr>
                        <template v-for="(cg, g) in car">
                            <template v-if="g != 'details'">
                                <tr class="tdm_sep" :key="'sep'+g"><th colspan="8"></th></tr>
                                <tr class="tdm_heading_opt" :key="'grp'+g">
                                    <th colspan="8" style="text-transform: capitalize;">{{ g }}</th>
                                </tr>
                                <template v-for="(item, i) in cg">
                                    <tr class="tdm_detail tdm_system" :key="i" v-if="item">
                                        <td class="tdm_include"><a class="js-item-remove" @click="removeCarItem(cn,g,i)">×</a></td>
                                        <td class="tdm_name">
                                            <select v-model="item.group_type" required class="promote-group" ref="group_type" :disabled="step != 2" @change="handleCategoryChange(cn, i)">
                                                <option value="">Select Category</option>
                                                <option v-for="(lbl, grp) in groups" :value="grp" :key="grp">{{ lbl }}</option>
                                            </select>
                                        </td>
                                        <td class="tdm_label">
                                            <select :ref="`itemKey${cn}${i}`" v-model="item.item_key" class="promote-label-value" :disabled="step != 2" required>
                                                <option value="">Select Label</option>
                                                <option v-for="labl in item.labels" :value="labl.label_key" :key="labl.id" :label="labl.label_desc">{{ labl.label_desc }}</option>
                                            </select>
                                        </td>
                                        <td class="tdm_qty">
                                            <template v-if="isReel(item.item)">
                                                <input type="number" class="itemqty promote-qty required" min="1" max="9999" maxlength="4" v-model="item.qty" @keyup="adjustRope(cn,g,i)">
                                            </template>
                                            <template v-else>
                                                <input type="number" class="itemqty promote-qty required" min="1" max="9999" maxlength="4" v-model="item.qty" :readonly="isRope(item)" @keyup="itemChange(item,0)">
                                            </template>
                                        </td>
                                        <td class="tdm_item">
                                            <input type="text" placeholder="Item" class="promote-item" @keyup="searchItem(item)" @blur="item.searched_items=false" v-model="item.item">
                                            <div class="item-list" v-if="item.searched_items">
                                                <template v-for="(si, i) in item.searched_items">
                                                    <a @click="addItem(item,si)" :key="i">{{ si.item }} <span>{{ si.price }}</span></a>
                                                </template>
                                            </div>
                                        </td>
                                        <td class="tdm_details">
                                            <template  v-if="isRope(item) && !pdata.cars[cn][g][i+1]">
                                                Add Reel first to edit details.
                                            </template>
                                            <template  v-else-if="isRope(item) && pdata.cars[cn][g][i+1]">
                                                ({{ pdata.cars[cn][g][i+1].qty }} X
                                                <input type="number" v-model="item.length" class="itemqty js-itemqty required itemlen" min="1" max="9999" maxlength="4" @keyup="adjustReel(cn,g,i)"> 
                                                ft Rope)
                                                <input type="hidden" placeholder="Item Details" class="promote-detail" v-model="item.detail">
                                            </template>
                                            <template  v-else>
                                                <input type="text" placeholder="Item Details" class="promote-detail" v-model="item.detail">
                                            </template>
                                        </td>
                                        <td class="tdm_uprice"><i>$</i> <input type="number" class="itemuprice promote-uprice required" min="0" max="9999" maxlength="8" :readonly="item.unit_price > 0 && !item.editable" v-model="item.unit_price" @keyup="itemChange(item,1)"></td>
                                        <td class="tdm_price"><i>$</i> <span>{{ sesCurr(item.price) }}</span></td>
                                    </tr>
                                </template>

                                <tr class="tdm_item-add tdm_item-system" data-tdmclone=".tdm_system" :key="'add'+g">
                                    <td class="tdm_include"></td>
                                    <td class="tdm_name" colspan="7">
                                        <a class="btn car-btn" @click="addItemList(cn,g)">Add Item</a>
                                        <select class="tdm-newitem" @change="addCarItem(cn,g,car.details.selector)" v-model="car.details.selector" v-if="false">
                                            <option value="">Add New Item</option>
                                            <option v-for="(sysname, syskey) in keys[g]" :key="syskey" :value="syskey" >{{ sysname }}</option>
                                        </select>
                                    </td>
                                </tr>

                                <tr class="tdm_subhead" data-tdmunitcost="1" data-tdmkey="machine" :key="'cost'+g">
                                    <td class="tdm_include"></td>
                                    <td class="tdm_name"><span>Unit Cost</span><i>:</i></td>
                                    <td class="tdm_qty"></td>
                                    <td class="tdm_item" colspan="4">× <span class="unit_qty">{{ car.details.car_qty }}</span></td>
                                    <td class="tdm_price"><i>$</i> <span>{{ sesCurr(car.details.unit_cost) }}</span></td>
                                </tr>

                                <tr class="tdm_subhead" data-tdmsubtotal="1" data-tdmkey="machine" :key="'sub'+g">
                                    <td class="tdm_include"></td>
                                    <td class="tdm_name"><span>Subtotal</span><i>:</i></td>
                                    <td class="tdm_qty"></td>
                                    <td class="tdm_item" colspan="4"></td>
                                    <td class="tdm_price"><i>$</i> <span>{{ sesCurr(car.details.subtotal) }}</span></td>
                                </tr>

                            </template>
                        </template>
                    </tbody>

                    <tr class="tdm_sep"><th colspan="8"></th></tr>

                    <tbody class="tdm_content">
                        <tr class="tdm_subhead" v-if="pdata.id == 'new'">
                            <td class="tdm_include"></td>
                            <td class="tdm_name" colspan="7"><a class="btn car-btn" @click="addCar()">Add New Car</a></td>
                        </tr>

                        <tr v-if="pdata.project.type !== 'stock'" class="tdm_subhead" data-dropship="x" data-tdmkey="machine">
                            <td class="tdm_include"><input type="checkbox" class="js-tdmdropship" v-model="pdata.dropship" :value="dsf" @change="dropOrFreight('dropship')"></td>
                            <td class="tdm_name"><span>Drop Ship Fee</span><i>:</i></td>
                            <td class="tdm_qty"></td>
                            <td class="tdm_item" colspan="4"></td>
                            <td class="tdm_price"><i>$</i> <span>{{ sesCurr(pdata.dropship) }}</span></td>
                        </tr>

                        <tr v-if="pdata.project.type === 'surchage'" class="tdm_subhead" data-dropship="x" data-tdmkey="machine">
                            <td class="tdm_include"><input type="checkbox" class="js-tdmdropship" v-model="pdata.freightsurcharge" value="900" @change="dropOrFreight('freightsurcharge')"></td>
                            <td class="tdm_name"><span>Freight Surcharge</span><i>:</i></td>
                            <td class="tdm_qty"></td>
                            <td class="tdm_item" colspan="4"></td>
                            <td class="tdm_price"><i>$</i> <span>{{ sesCurr(pdata.freightsurcharge) }}</span></td>
                        </tr>

                        <tr class="tdm_sep"><th colspan="8"></th></tr><tr class="tdm_subhead" data-grandtotal="x" data-tdmkey="machine">
                            <td class="tdm_include"></td>
                            <td class="tdm_name"><span>Grand Total</span><i>:</i></td>
                            <td class="tdm_qty"></td>
                            <td class="tdm_item" colspan="4"></td>
                            <td class="tdm_price"><i>$</i> <span>{{ sesCurr(pdata.grandtotal) }}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
        <template slot="footer">
            <a class="btn float-left" v-if="step == 1" @click="closeModal">Cancel</a>
            <a class="btn float-left" v-if="step == 1 && parseInt(pdata.id) > 0 && allowRepromote" @click="repromote">
                <template v-if="rePromoting"><span class="fa fa-spinner fa-pulse"></span> Repromote</template>
                <template v-else>Repromote</template>
            </a>
            <a class="btn btn-black" v-if="step == 1" @click="showItems">Next</a>
            <a class="btn" v-if="step == 2" @click="showFiles">Back</a>
            <a class="btn btn-black" v-if="step == 2" @click="savePromote">
                <template v-if="promoting"><span class="fa fa-spinner fa-pulse"></span></template>
                <template v-else>Promote</template>
            </a>
        </template>
    </modal>
</template>
<script>
  import MaskedInput from 'vue-masked-input';

  export default {
    name: "promotion",
    components: { MaskedInput },
    props: {
      pdata: {
        type: [String, Object, Array, Boolean],
        default: "",
        description: "Model"
      },
    },
    data() {
      return {
        step: 1,
        toggled: false,
        promoting: false,
        dsf: 900,
        reseter: { counter : 1 },
        selector : {
            system : {},
            component : {},
        },
        groups : {
            machine         : "Machine",
            bedplate_system : "Bedplate Systems",
            other_system    : "Other System Items",
            components      : "Optional Components",
            door_system     : "Door System",
            controller      : "Controller",
            guide_rail      : "Guide Rail",
            hoistway        : "Hoistway Components",
            hpu             : "Hydraulic System",
            wire_rope       : "Wire Rope Component",
            compensation    : "Compensation",
            cssv            : "Compounding Sheave"
        },
        keys : {
            system : {
                machine              : 'Machine',
                bedplate             : 'Bedplate',
                short_rope           : 'Short Rope to Wall',
                riser                : 'Bedplate Riser',
                rope_gripper         : 'Rope Gripper',
                deflector            : 'Deflector',
                machine_sheave       : 'Custom Machine Sheave',
                rope_guard           : 'Rope Guard',
                hitch_plate_car_side : 'Hitch Plate Car Side',
                hitch_plate_cwt_side : 'Hitch Plate CWT Side',
                ss_car_side          : 'Compounding Sheave Car Side',
                ss_cwt_side          : 'Compounding Sheave CWT Side',
                encoder_cable        : 'Encoder Cable',
                onsite_assembly      : 'Assembly',
                tpm_flat_mount       : 'TPM Flat Mount',
                others               : 'Other',
            },
            component : {
                roller_carside         : 'Roller Guide Car Side',
                roller_cwtside         : 'Roller Guide CWT Side',
                governor               : 'Governor 12"',
                governor_ts            : 'Governor Tension Sheave',
                governor_ls            : 'Governor Live Shaft',
                oilbuffer_carside      : 'Oil Buffer Car Side',
                oilbuffer_cwtside      : 'Oil Buffer CWT Side',
                wedge_socket_carside_1 : 'Wedge Socket Car Side',
                wedge_socket_cwtside_1 : 'Wedge Socket CWT Side',
                spring                 : 'Wedge Socket Spring CWT Side',
                light_curtain          : 'Light Curtain',
                hoist_rope             : 'Hoist Rope',
                governor_rope          : 'Governor Rope',
                others                 : 'Other',
            },
            custom : {}
        },
        sesLabels: this.pdata.ses_labels,
        showManageWarningNotes: false,
        warningNotes: {},
        removedWarningNotes: [],
        warningMessages: [],
        rePromoting: false,
        allowRepromote: false
      };
    },
    mounted() {
        this.getItems()
        if(this.pdata) {
            if ( this.pdata.details.drop_ship_value ) {
                this.dsf = this.pdata.details.drop_ship_value;
            }
            this.warningNotes = this.pdata.warning_notes
            this.warningMessages = this.pdata.warning_messages
            this.allowRepromote = this.pdata.allow_repromote
            delete this.pdata.warning_notes
            delete this.pdata.warning_messages
            this.calculate()
        }
    },
    watch: {
        'pdata'(n) {
            if(n) {
                if ( n.details.drop_ship_value ) {
                    this.dsf = n.details.drop_ship_value;
                }
                console.log('n.details.drop_ship_value',n.details.drop_ship_value);
                console.log('this.dsf',this.dsf);
                this.calculate()
            }
        }
    },
    methods: {
        isRope(item) {
            let rope = item.item.substring(0, 3) === '80-';
            if ( rope && !item.length && item.detail ) {
                let desc = item.detail.split(' '),
                    len = (desc && desc[0] && desc[2]) ? desc[2] : 0;
                item.length = len;
            }
            return rope;
        },
        isReel(item) {
            return item.toLowerCase().includes(' reel');
        },
        prevKey(cn,g,i) {
            let keys = Object.keys(this.pdata.cars[cn][g]);
            let nextIndex = keys.indexOf(i) - 1;
            return keys[nextIndex];
        },
        nextKey(cn,g,i) {
            let keys = Object.keys(this.pdata.cars[cn][g]);
            let nextIndex = keys.indexOf(i) + 1;
            return keys[nextIndex];
        },
        adjustRope(cn,g,i) {
            let item = this.pdata.cars[cn][g][i-1],
                reel = this.pdata.cars[cn][g][i].qty,
                len = item.length,
                currentItem = this.pdata.cars[cn][g][i];
            item.qty = reel * len;
            item.reel = reel;
            item.detail = '('+reel+' X '+len+' ft Rope)';
            item.price = item.qty * item.unit_price;
            currentItem.price = currentItem.qty * currentItem.unit_price;

            this.calculate();
            this.subReset();
            return false;
        },
        adjustReel(cn,g,i) {
            let item = this.pdata.cars[cn][g][i],
                reel = this.pdata.cars[cn][g][i+1].qty,
                len = item.length;
            item.qty = reel * len;
            item.detail = '('+reel+' X '+len+' ft Rope)';
            item.price = item.qty * item.unit_price;

            this.calculate();
            this.subReset();
            return false;
        },
        getItems() {
            if(this.pdata.project != undefined) {
                var nid = this.pdata.project.customer_id ? this.pdata.project.customer_id : 0;
                this.$http.get('/api/promote/citems/'+nid+'/'+this.pdata.project.type).then((r) => { 
                    this.pdata.items = r.data;
                    this.reprice();
                });
            }
        },
        getPromotionPriceLevelLabel() {
            const nid = this.pdata.project.customer_id ? this.pdata.project.customer_id : 0;
            this.$http.get('/api/promote/price-level/'+nid, { params: { type: this.pdata.project.type } }).then((res) => {
                this.pdata.details.level_desc = res.data.level_desc;
            });
        },
        getRelatedData() {
            if (this.pdata.project.type != '') {
                this.getItems()
                this.getPromotionPriceLevelLabel()
            }
        },
        closeModal() {
            this.pdata = false;
            this.$emit('close', true);
        },
        showItems() {
            if ( !this.checkData() ) return false;
            ++this.step;
        },
        checkData(){
            var hasEmpty = false,
                firstEl = false,
                item = false,
                errors = {};

            for(var i in this.$refs) {
                const _el = this.$refs[i];
                if ( Array.isArray(_el) ) {
                    for (var x in _el) {
                        item = _el[x];
                        if ( item && item.required && !item.disabled && (item.value == '' || item.value == undefined) ) {
                            hasEmpty = true;
                            if ( !firstEl ) firstEl = item;
                        }
                    }
                } else {
                    item = _el;
                    if ( item && item.required && !item.disabled && (item.value == '' || item.value == undefined) ) {
                        hasEmpty = true;
                        if ( !firstEl ) firstEl = item;
                        errors['show'] = true;
                        console.log(item);
                    }
                }
            }

            if ( this.step == 2 ) {
                for( var cn in this.pdata.cars ) {
                    for( var g in this.pdata.cars[cn] ) {
                        for( var it in this.pdata.cars[cn][g] ) {
                            var itm = this.pdata.cars[cn][g][it].item;
                            if ( itm && itm !== undefined && !this.isActive(itm) ) {
                                alert('This item is non-existent: '+itm);
                                return false;
                            }
                        }
                    }
                }
            }

            if ( hasEmpty ) {
                alert('Please fill all required data.');
                console.log(firstEl);
                firstEl.focus();
                return false;
            }
            return true;
        },
        subReset(){
            var ctr = this.reseter.counter;
            this.$set(this.reseter,'counter',ctr+2);
            this.$set(this.reseter,'counter',ctr+1);
        },
        addCar() {
            const ncn = Object.keys(this.pdata.cars).length + 1;
            this.pdata.cars[ncn] = {
                custom: [
                    {
                        item: "",
                        item_key: "",
                        label: "Machines",
                        parent: "",
                        pgroup: "machine",
                        price: "0.00",
                        qty: 1,
                        unit_price: "0.00",
                    }
                ],
                details: {
                    car_id_number: "",
                    car_qty: 1,
                }
            };
            this.warningNotes[ncn] = {
                car_id_number: '',
                rows: [{
                    id: 900001,
                    group_type: '',
                    warning_msg: '',
                    action: 'add',
                    warning_code: '',
                    survey_id: 'new'
                }]
            }
            this.subReset();
        },
        removeCar(cn) {
            const ncn = Object.keys(this.pdata.cars).length;
            delete this.pdata.cars[cn];
            for (var i = parseInt(cn); i < ncn; i++) {
                this.pdata.cars[i] = this.pdata.cars[parseInt(i) + 1];
            }
            if (this.pdata.id === 'new') {
                delete this.warningNotes[cn];
            }
            this.subReset();
        },
        addItemList(cn,g) {
            if ( !this.pdata.cars[cn][g] ) this.pdata.cars[cn][g] = {};

            this.pdata.cars[cn][g].push({
                item_key   : "",
                label      : "Enter Item",
                qty        : 1,
                item       : '',
                parent     : '',
                price      : '0.00',
                unit_price : '0.00',
                pgroup     : g,
            });

            this.subReset();
        },
        addCarItem(cn,g,type) {
            if ( !type ) return false;
            // var item_key = type;
            if ( !this.pdata.cars[cn][g] ) this.pdata.cars[cn][g] = [];
            // if ( type == 'others' ) {
            //     for (var i = 1; i <= 20; i++) {
            //         if ( !this.pdata.cars[cn][g][type+"_"+i] ) {
            //             item_key = type+"_"+i;
            //             break;
            //         }
            //     }
            // }

            // if ( !this.pdata.cars[cn][g][item_key] ) this.pdata.cars[cn][g][item_key] = {};

            this.pdata.cars[cn][g].push({
                // item_key   : item_key,
                item_key   : '',
                label      : this.keys[g][type],
                qty        : 1,
                item       : '',
                parent     : '',
                price      : '0.00',
                unit_price : '0.00',
                pgroup     : g,
            });

            this.pdata.cars[cn].details.selector = '';

            this.subReset();
        },
        sesCurr(val) {
            return this.formatMoney(val, 2, '.', ',');
        },
        formatMoney(number, decPlaces, decSep, thouSep) {
            decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
            decSep = typeof decSep === "undefined" ? "." : decSep;
            thouSep = typeof thouSep === "undefined" ? "," : thouSep;
            var sign = number < 0 ? "-" : "";
            var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
            var j = (j = i.length) > 3 ? j % 3 : 0;

            return sign +
                (j ? i.substr(0, j) + thouSep : "") +
                i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
                (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
        },
        addItem(item,si) {
            item.item = si.item;
            item.unit_price = si.price;
            item.price = item.qty * si.price;
            // item.item_key = si.group.split(' ').join('_');
            item.item_key = (item.item_key === '') ? '' : item.item_key
            item.label = si.group;
            item.searched_items = false;
            item.editable = !si.price ? 1 : 0;

            this.calculate();
            this.subReset();
        },
        itemChange(item,editable) {
            if( editable ) item.editable = editable;
            item.price = item.qty * item.unit_price;

            this.calculate();
            this.subReset();
        },
        reprice() {
            var item = '', price = 0;
            for ( var cn in this.pdata.cars ) {
                for ( var g in this.pdata.cars[cn] ) {
                    if ( g == 'details' ) continue;
                    for ( var i in this.pdata.cars[cn][g] ) {
                        item = this.pdata.cars[cn][g][i];
                        price = this.getPrice(item.item);
                        if ( !price || price <= 0 ) continue;
                        this.pdata.cars[cn][g][i].unit_price = price;
                        this.pdata.cars[cn][g][i].price = price * item.qty;
                    }
                }
            }
            this.calculate();
        },
        dropOrFreight(type) {
            if ( type == 'dropship' && this.pdata.dropship ) this.pdata.freightsurcharge = 0;
            if ( type == 'freightsurcharge' && this.pdata.freightsurcharge ) this.pdata.dropship = 0;
            this.calculate();
        },
        calculate() {
            var unit_costs = {},
                subtotals = {},
                grandtotal = 0,
                dropship = this.pdata.dropship ? this.dsf : 0,
                freightsurcharge = 0;
            for ( var cn in this.pdata.cars ) {
                for ( var g in this.pdata.cars[cn] ) {
                    if ( g == 'details' ) continue;
                    for ( var i in this.pdata.cars[cn][g] ) {
                        if ( !this.pdata.cars[cn][g][i].price ) continue;
                        if ( !unit_costs[cn] ) unit_costs[cn] = 0;
                        if ( !subtotals[cn] ) subtotals[cn] = 0;
                        unit_costs[cn] += parseFloat(this.pdata.cars[cn][g][i].price);
                        subtotals[cn] += parseFloat(this.pdata.cars[cn][g][i].price);
                    }
                }
            }

            this.keys.custom = this.pdata.categories;

            for( var s in subtotals ) {
                this.pdata.cars[s].details.unit_cost = subtotals[s];
                subtotals[s] *= parseInt(this.pdata.cars[s].details.car_qty);
                this.pdata.cars[s].details.subtotal = subtotals[s];
                grandtotal += subtotals[s];
            }
            this.pdata.dropship = dropship;
            this.pdata.freightsurcharge = freightsurcharge;
            this.pdata.grandtotal = dropship + freightsurcharge + grandtotal;

            this.subReset();
        },
        searchItem(item) {
            var tosearch = item.item.toLowerCase(),
                // g = item.item_key.split('_').join(' '),
                items = [];

            for (var i in this.pdata.items) {
                var _item = this.pdata.items[i];
                if ( _item.item.toLowerCase().indexOf(tosearch) > -1 ) {
                    items.push({
                        item : _item.item,
                        group : _item.item_group,
                        price : _item.price,
                    });
                }
            }
            item.searched_items = items;
            this.subReset();
        },
        removeCarItem(cn,g,i) {
            delete this.pdata.cars[cn][g][i];
            this.calculate();
        },
        showFiles() {
            --this.step;
        },
        getPrice(item) {
            for( var i in this.pdata.items ) {
                if ( this.pdata.items[i].item == item ) return this.pdata.items[i].price;
            }
            return 0;
        },
        isActive(item) {
            for( var i in this.pdata.items ) {
                if ( this.pdata.items[i].item.toLowerCase() == item.toLowerCase() ) return true;
            }
            return false;
        },
        storeFile(key) {
            if ( !this.pdata.files ) this.pdata.files = {};
            this.pdata.files[key] = this.$refs[key] ? this.$refs[key].files : '';
        },
        savePromote() {
            if ( !this.checkData() ) return false;
            this.pdata.warn_notes = this.warningNotes
            this.pdata.removed_warning_notes = this.removedWarningNotes
            let postdata = new FormData(),
                data = { ...{}, ...this.pdata };
            data.items = '';
            for(let prop in data) {
                if ( prop == 'files' ) {
                    for(let f in data[prop] ) {
                        for( var i = 0; i < data[prop][f].length; i++ ){
                            let file = data[prop][f][i];
                            postdata.append('pdfs['+f+']['+i+']', file);
                        }
                    }
                } else {
                    postdata.append(prop, JSON.stringify(data[prop]))
                }
            }
            if ( this.promoting ) return false;
            this.promoting = true;
            this.$http.post('/api/promote/save', postdata, { headers: { 'Content-Type': 'multipart/form-data'} } )
                .then((response) => {
                    if ( response.data.status == 'success' ) {
                        alert('Successfully Promoted!');
                        this.$emit('reload', true);
                        this.closeModal();
                    } else {
                        alert('Something went wrong!');
                    }
                    this.$emit('close', true)
                    this.promoting = false;
                })
                .catch(() => {
                    this.promoting = false;
                    alert('Something went wrong!');
                })
            console.log('save_promote');
        },
        repromote() {
            const toRePromote = { projectID: this.pdata.id }
            this.rePromoting = true
            this.$http.post('/api/promote/repromote', toRePromote )
                .then((response) => {
                    if ( response.data.status == 'success' ) {
                        alert('Successfully Promoted!');
                        this.$emit('reload', true);
                        this.closeModal();
                    } else {
                        alert('Something went wrong!');
                    }
                    this.$emit('close', true)
                    this.rePromoting = false;
                })
                .catch(() => {
                    this.rePromoting = false;
                    alert('Something went wrong!');
                })
        },
        handleCategoryChange(cn, i) {
            const list = this.sesLabels.filter(itm => itm.group_type === this.pdata.cars[cn].custom[i].group_type)
            this.pdata.cars[cn].custom[i].labels = list
            this.subReset();
        },
        removeWarningNote(carNum, wnDIndex, wnDetailId) {
            this.warningNotes[carNum].rows.splice(wnDIndex, 1)
            if (wnDetailId < 800000) {
                this.removedWarningNotes.push({
                    car_num: carNum,
                    warning_index: wnDIndex,
                    warning_note_id: wnDetailId
                })
            }
            this.subReset();
        },
        manageWarnings() {
            this.showManageWarningNotes = !this.showManageWarningNotes
        },
        addWarning(wnCn) {
            let len = this.warningNotes[wnCn].rows.length
            this.warningNotes[wnCn].rows.push(
                {
                    id: 900000 + (++len),
                    group_type: '',
                    warning_msg: '',
                    action: 'add',
                    warning_code: '',
                    survey_id: this.pdata.id
                }
            );
        },
        handleWarningCodeChange(event, wnCn, wnDIndex) {
            const codeValue = event.target.value
            if (codeValue !== '') {
                const msg = this.warningMessages[this.warningMessages.findIndex(item => item.warning_number === codeValue)].warning_text
                this.warningNotes[wnCn].rows[wnDIndex].warning_msg = msg
            } else {
                this.warningNotes[wnCn].rows[wnDIndex].warning_msg = ''
            }
            this.subReset();
        },
        handleNewCarName(event, cn) {
            if (this.pdata.id === 'new') {
                this.warningNotes[cn].car_id_number = event.target.value
            }
            this.subReset();
        }
    }
  };
</script>
<style>
    #promoteModal .modal-dialog { width: 1357px; }
    .modal-step { padding: 0 15px; }

    .tdm_item { position: relative; }
    .item-list { position: absolute; top: 100%; left: 0px; width: auto; min-width: 100%; max-height: 200px; overflow: auto; z-index: 10; background: #FFF; box-shadow: 0px 0px 5px #333; }
    .item-list a { display: block; border-top: 1px solid #eee; border-bottom: 1px solid #ddd; padding: 4px 100px 4px 10px; position: relative; color: #333; white-space: nowrap; cursor: pointer; }
    .item-list a span { position: absolute; top: 4px; right: 10px; }
    .item-list a:hover { background: blue; color: #FFF; }

    .pdf-group { border: 1px solid #ccc; padding: 10px; display: block; overflow: hidden; }
    .pdf-group label { margin-bottom: 5px; font-weight: 700; }
    .pdf-group input[type=file] { width: 100%; display: block; }
    .pdf-row > div { padding: 3px 3px; }

    .tdm_table { width: 100%; }
    .tdm_table th, .tdm_table td { padding: 2px 10px; text-align: left; }
    .tdm_table td { border: 1px solid #d2d2d2; text-align: left; }
    .tdm_include { width: 32px; text-align: center; line-height: 13px; }
    .tdm_include input { width: 17px; height: 17px; }
    .tdm_name { width: 260px; }
    .tdm_label { width: 247px; }
    .tdm_qty { width: 52px; text-align: center; }
    .tdm_subhead { font-weight: bold; }
    .tdm_subhead .tdm_item { text-align: right; }
    .tdm_price { width: 140px; }
    td.tdm_price { text-align: right; }
    .tdm_price i { font-style: normal; float: left; }
    .js-item-remove { background: red; color: #FFF; padding: 2px 8px; display: inline-block; border-radius: 3px; margin: -3px -5px; cursor: pointer; border: 1px solid red; }
    .itemqty {width: 70px;text-align: center;padding: 0 0 0 16px;margin: 0px -8px;}
    .promote-group,
    .promote-item,
    .promote-label-value,
    .promote-detail {width: calc(100% + 16px);margin: 0 -8px;}
    .tdm_table input, .tdm_table select { border-radius: 0;border: 1px solid #000;padding: 3px 6px;box-shadow: none;}
    .tdm_table input[readonly] { border-color: transparent;}
    .itemuprice { width: 145px; text-align: right; }
    .rmv-car { color: red !important; font-size: 10px; font-weight: 400; white-space: nowrap; cursor: pointer; }
    .btn.car-btn { background: #000; color: #FFF !important; padding: 3px 17px; }
    .btn.car-btn:hover { color: #FFF !important; }
    .tdm_uprice, .tdm_price { position: relative; }
    .tdm_uprice i, .tdm_price i{ position: absolute; top: 50%; left: 4px; transform: translateY(-50%); font-style: normal; }
    .tdm_uprice input, .tdm_price input{ margin-left: 6px; width: 100%; }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .1s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .warning-table {
        border-collapse: collapse !important;
        width: 100%;
        margin-bottom: 10px;
    }
    .warning-table td {
        border: 1px solid #d2d2d2 !important;
        padding: 2px;
    }
    .warning-table th {
        padding: 2px 10px !important;
    }
    .warning-table td:first-child{
        text-align: center !important;
    }
    .warning-table-container {
        width: 100% !important;
        /*min-height: 250px;*/
        margin-bottom: 25px;
    }
    .warning-table .warning-note {
        border-radius: 0;
        border: 1px solid #000;
        padding: 3px 6px;
        box-shadow: none;
        width: 100%;
    }
    .warning-table .warning-category {
        width: 260px !important;
        padding: 2px 6px;
    }
    .warning-table .warning-code-td {
        width: 175px;
    }
    .warning-table .warning-category-none {
      padding: 0
    }
    .warning-table .warning-code-td-none {
      padding: 0;
    }
    .warning-table .rm-warning-none {
      padding: 0;
    }
    .warning-table .warning-note-td-none {
      padding: 0;
    }
    .warning-table .wn-warning-code {
        width: 100%;
    }
    .warning-table .rm-warning {
        min-width: 37px;
        max-width: 37px;
        width: 37px;
        line-height: 13px;
    }
    .warning-note-td {
        width: 790px !important;
    }
    .add-wnbutton {
        width: 260px !important;
    }
    @media only screen and (max-width: 812px) {
        .warning-table .warning-category {
            width: 135px !important;
        }
        .warning-table .add-wnbutton {
            width: 135px !important;
        }
    }
    .wn-category {
        border-radius: 0;
        border: 1px solid #000;
        padding: 3px 6px;
        box-shadow: none;
        width: 100%;
    }
    .wn-warning-code {
        border-radius: 0;
        border: 1px solid #000;
        padding: 3px 6px;
        box-shadow: none;
        width: 100%;
    }
    .wn-remove {
        min-width: 37px;
        max-width: 37px;
        width: 37px;
        line-height: 13px;
    }
</style>
<style lang="scss" scoped>
    .modal::v-deep {
        .modal-dialog {
            width: 970px;
            max-width: calc(100% - 60px);
        }
    }

    .itemlen {
        margin-left: 0px !important;
        margin-right: 0px !important;
    }
</style>